import { Link, Route } from 'react-router-dom';

type Props = {
  id: string;
};

export function Bookmark({ id }: Props) {
  return <div id={id} className={'hash-bookmark'} />;
}
